export default {
  getChurchList: state => state.churchList
};
